// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`15.1|151.04000|146.2|159.18000|000.0|H|N|
15.2|156.24000|127.3|159.10500|000.0|H|N|
15.3|151.26500|103.5|159.33000|000.0|H|N|
15.4|151.22000|192.8|151.22000|192.8|L|N|
15.5|159.26250|192.8|159.26250|192.8|L|N|
15.6|159.36750|192.8|159.36750|192.8|L|N|
15.7|158.83500|82.5|158.83500|82.5|H|N|
15.8|155.89500|82.5|155.89500|82.5|L|N|
15.9|154.28000|156.7|154.28000|156.7|H|N|
15.10|154.26500|156.7|154.26500|156.7|L|N|
15.11|154.29500|156.7|154.29500|156.7|L|N|
15.12|154.27250|156.7|154.27250|156.7|L|N|
15.13|154.28750|156.7|154.28750|156.7|L|N|
15.14|154.30250|156.7|154.30250|156.7|L|N|
15.15|151.25750|192.8|151.25750|192.8|L|N|
15.16|151.19000|192.8|151.19000|192.8|L|N|
15.17|151.13750|156.7|151.13750|156.7|L|N|
15.18|154.45250|156.7|154.45250|156.7|L|N|
15.19|158.73750|156.7|158.73750|156.7|L|N|
15.20|159.47250|156.7|159.47250|156.7|L|N|
15.21|156.07500|156.7|156.07500|156.7|H|N|
15.22|151.46000|136.5|159.39000|000.0|H|N|
15.23|155.26500|123.0|159.45750|000.0|H|N|
15.24|154.17500|156.7|159.41250|000.0|H|N|
15.25|169.71250|110.9|162.16250|000.0|H|N|
15.26|171.16250|110.9|164.08750|000.0|H|N|
15.27|157.05000|000.0|157.05000|000.0|L|W|
15.28|157.10000|000.0|157.10000|000.0|L|W|
15.29|156.30000|000.0|156.30000|000.0|L|W|
15.30|156.60000|000.0|156.60000|000.0|L|W|
15.31|156.80000|000.0|156.80000|000.0|L|W|
15.32|157.15000|000.0|157.15000|000.0|L|W|
15.33|157.07500|000.0|157.07500|000.0|L|W|
15.34|157.17500|000.0|157.17500|000.0|L|W|
15.35|162.50000|000.0|000.00000|000.0||W|
15.36|162.47500|000.0|000.00000|000.0||W|
15.37|168.62500|000.0|168.62500|110.9|L|N|Emergency
16.1|151.44500|156.7|159.34500|000.0|H|N|
16.2|151.12250|156.7|159.16500|000.0|H|N|
16.3|151.35500|103.5|159.30000|000.0|H|N|
16.4|151.26500|103.5|159.33000|000.0|H|N|
16.5|151.40000|103.5|159.37500|000.0|H|N|
16.6|151.16000|192.8|151.16000|192.8|L|N|
16.7|151.32500|192.8|151.32500|192.8|L|N|
16.8|151.38500|192.8|151.38500|192.8|L|N|
16.9|151.40000|192.8|151.40000|192.8|L|N|
16.10|154.28000|156.7|154.28000|156.7|H|N|
16.11|154.26500|156.7|154.26500|156.7|L|N|
16.12|154.29500|156.7|154.29500|156.7|L|N|
16.13|154.30250|156.7|154.30250|156.7|L|N|
16.14|151.22000|192.8|151.22000|192.8|L|N|
16.15|159.26250|192.8|159.26250|192.8|L|N|
16.16|159.36750|192.8|159.36750|192.8|L|N|
16.17|156.07500|156.7|156.07500|156.7|H|N|
16.18|155.47500|156.7|150.79000|156.7|H|N|
16.19|154.34000|162.2|155.89500|162.2|H|N|
16.20|153.83000|000.0|153.83000|000.0|L|N|
16.21|155.80500|D445|153.90500|D445|H|N|HOLLISTER FIRE PRI
16.22|155.52000|000.0|155.52000|162.2|L|N|HOLLISTER FIRE TAC 1
16.23|155.55000|000.0|155.55000|146.2|L|N|HOLISTER FIRE TAC 2
16.24|151.02500|146.2|156.12000|146.2|H|N|HOLLISTER NCNTY
16.25|151.02500|146.2|156.12000|110.9|H|N|HOLLISTER SCNTY
16.26|155.02500|173.8|154.01000|173.8|H|N|
16.27|155.92500|123.0|154.35500|123.0|H|N|
16.28|153.98000|151.4|155.82000|151.4|H|N|
16.29|154.11500|136.5|155.88000|136.5|H|N|
16.30|154.43000|118.8|154.43000|118.8|L|N|
16.31|154.31000|127.3|154.31000|127.3|L|N|
16.32|151.04000|103.5|151.04000|103.5|L|N|
16.33|150.77500|91.5|150.77500|91.5|L|N|
16.34|155.13000|229.1|155.13000|229.1|L|N|
16.35|150.80500|225.7|150.80500|225.7|L|N|
16.36|154.25000|162.2|158.35500|162.2|H|N|
16.37|155.98500|179.9|158.95500|167.9|H|N|
16.38|154.17500|162.2|154.17500|162.2|L|N|
16.39|154.20500|179.9|154.20500|179.9|L|N|
16.40|154.14500|192.8|154.14500|192.8|L|N|
16.41|154.40000|110.9|154.40000|110.9|L|N|
16.42|153.90500|192.8|153.90500|192.8|L|N|
16.43|153.84500|000.0|153.84500|000.0|H|N|
16.44|155.76000|103.5|158.82000|103.5|H|N|
16.45|153.77000|110.9|154.44500|110.9|H|N|
16.46|154.05500|110.9|156.06000|110.9|H|N|
16.47|154.02500|110.9|154.99500|110.9|H|N|
16.48|154.83000|141.3|156.61000|141.3|H|N|
16.49|158.86500|110.9|158.86500|110.9|L|N|
16.50|151.62500|173.8|151.62500|173.8|L|N|
16.51|151.92500|173.8|151.92500|173.8|L|N|
16.52|152.94500|156.7|152.94500|156.7|L|N|DIRECT
16.53|152.94500|156.7|160.14000|173.8|H|N|
16.54|152.94500|156.7|160.14000|DPL 503|H|N|
16.55|152.94500|156.7|160.14000|DPL 306|H|N|
16.56|151.14500|107.2|159.12000|131.8|H|N|
16.57|152.09000|146.2|158.55000|146.2|H|N|
16.58|153.77000|123.0|153.77000|123.0|H|N|
16.59|154.43000|NAC 122|154.05500|NAC 122|H|N|CMD 2, P25 ID 37184, C4FM
16.60|151.01000|82.5|153.87500|82.5|H|N|Stanislaus Co CMD 3
16.61|155.08500|NAC 124|156.09000|NAC 124|H|N|CMD4, P25 ID 37184, C4FM
16.62|155.94000|NAC 125|154.14500|NAC 125|H|N|P25 ID 37184, CQPSK
16.63|154.37000|NAC 127|154.37000|NAC 127|L|N|Tac 7, P25 ID 37184, C4FM
16.64|153.90500|NAC 128|153.90500|NAC 128|L|N|Tac 8, P25 ID 37184, C4FM
16.65|154.32500|NAC 129|154.32500|NAC 129|L|N|Tac 9, P25 ID 37184, C4FM
16.66|153.89000|NAC 130|153.89000|NAC 130|L|N|Tac 10, P25 ID 37184, C4FM
16.67|154.41500|NAC 131|154.41500|NAC 131|L|N|Tac 11, P25 ID 37184, C4FM
16.68|154.19000|NAC 132|154.19000|NAC 132|L|N|Tac 12, P25 ID 37184, C4FM
16.69|154.43000|123.0|154.05500|123.0|H|N|XST CMD 2 (ANALOG)
16.70|151.01000|D343|153.87500|D343|H|N|
16.71|155.08500|D464|156.09000|D464|H|N|XST COMMAND 4 (ANALOG)
16.72|154.37000|123.0|154.37000|123.0|L|N|XST TAC 7 (ANALOG)
16.73|153.90500|123.0|153.90500|123.0|L|N|XST TAC 8 (ANALOG)
16.74|154.32500|123.0|154.32500|123.0|L|N|XST TAC 9 (ANALOG)
16.75|153.89000|123.0|153.89000|123.0|L|N|XST TAC 10 (ANALOG)
16.76|154.07000|000.0|154.07000|000.0|L|N|
16.77|154.23500|000.0|154.23500|000.0|L|N|
16.78|159.61500|186.2|154.20500|186.2|H|N|
16.79|160.11000|141.3|151.02500|141.3|H|N|
16.80|159.73500|156.7|154.20500|156.7|H|N|
16.81|153.99500|100.0|154.99500|D162|H|N|
16.82|154.38500|136.5|155.82000|156.7|H|N|
16.83|154.72500|D165|158.89500|D165|H|N|
16.84|155.89500|D165|153.81500|D165|H|N|
16.85|156.18750|D165|156.18750|D165|L|N|
16.86|154.10750|D165|154.10750|D165|L|N|
16.87|152.35250|100.0|157.58250|D143|H|N|
16.88|156.24000|D565|156.24000|D565|L|N|
16.89|151.07750|D143|155.84250|D143|H|N|
16.90|155.59500|110.9|155.59500|110.9|L|N|
16.91|151.28000|000.0|000.00000|000.0|H|N|
16.92|151.29500|000.0|000.00000|000.0|H|N|
16.93|151.31000|000.0|000.00000|000.0|H|N|
16.94|158.73000|250 NAC|000.00000|000.0||N|P25 ID 37184, C4FM
16.95|155.07000|246 NAC|000.00000|000.0||N|P25 ID 37184, C4FM
16.96|153.75500|000.0|154.98000|000.0|H|N|Travel Net
16.97|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
